"use client"
import React from "react";

const SmoothScrollButton = ({ targetId, buttonText }) => {
  const handleClick = () => {
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offset = targetElement.getBoundingClientRect().top - 125; // Ajusta aquí el valor de desplazamiento (en este caso, 100px)
      const startPosition = window.pageYOffset;
      const startTime =
        "now" in window.performance ? performance.now() : new Date().getTime();
      const duration = 1000; // Duración de la animación en milisegundos

      function scroll() {
        const currentTime =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime();
        const timeElapsed = currentTime - startTime;

        window.scrollTo(
          0,
          easeInOutQuad(timeElapsed, startPosition, offset, duration)
        );

        if (timeElapsed < duration) {
          requestAnimationFrame(scroll);
        }
      }

      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }

      scroll();
    }
  };

  return (
    <button onClick={handleClick} className="BtnScrollToID">
      {buttonText}
    </button>
  );
};

export default SmoothScrollButton;
